import React from 'react'
import { Badge, Col, Row, Tag, Tooltip } from 'antd'
import styled from 'styled-components'

type Props = {
  text: string
  isPass?: boolean
  color?: string
  tooltip?: string
}

const StatusTag = (props: Props) => {
  const { text, isPass = true, color = '', tooltip = '' } = props
  let tagColor = ''
  if (color) {
    tagColor = color
  } else {
    tagColor = isPass ? 'green' : 'red'
  }

  return (
    <Tooltip title={`${tooltip || text}`} color={tagColor} key={tagColor}>
      <StatusTagWrapper color={tagColor} style={{ cursor: 'default' }}>
        <Row align="stretch" justify="start" wrap={false} gutter={8}>
          {tagColor && (
            <Col style={{ width: '10px' }}>
              <MyBadge key={tagColor} color={tagColor === 'default' ? 'grey' : tagColor} />
            </Col>
          )}
          <Col>
            <Text>{text}</Text>
          </Col>
        </Row>
      </StatusTagWrapper>
    </Tooltip>
  )
}

const StatusTagWrapper = styled(Tag)`
  border-radius: 15px;
  //border: 1px solid;
  max-width: 100%;
`

const MyBadge = styled(Badge)`
  width: 20px;
  overflow: visible;
`

const Text = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export default StatusTag
